import cn from 'classnames';

import { Button } from '@/components/Button';
import { Link } from '@/components/Link';
import { Wrapper } from '@/components/Wrapper';

import { DirectionSlide } from '../../CarouselBase/slides/DirectionSlide';
import { PeopleSlide } from '../../CarouselBase/slides/PeopleSlide';
import s from './AutoScrolled.module.scss';

interface SlideProps {
  image?: string;
  link?: string;
  badge?: {
    name: string;
    position: string;
  };
  title?: string;
  description: string;
}

interface AutoScrolledProps {
  title: string;
  subtitle: string;
  slides: SlideProps[];
  button?: {
    title: string;
    link: string;
  };
  variant: 'descriptions' | 'people';
}

const AutoScrolled = ({
  title,
  subtitle,
  slides,
  button,
  variant,
}: AutoScrolledProps) => {
  return (
    <section className={cn(s.root)}>
      <Wrapper className={s.head}>
        <h2 className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
        <h3 className={s.subtitle}>{subtitle}</h3>
      </Wrapper>
      <div className={s.wrapper}>
        {[0, 1].map((_, index) => {
          return (
            <div className={s.slidesWrapper} key={index}>
              {slides.map(
                ({ title, badge, image, link, description }, index) => {
                  if (variant === 'people') {
                    return (
                      <PeopleSlide
                        title={title}
                        badge={badge}
                        image={image}
                        link={link}
                        description={description}
                        key={index}
                      />
                    );
                  }

                  return (
                    <DirectionSlide
                      title={title!}
                      badge={badge}
                      image={image}
                      link={link!}
                      description={description}
                      key={index}
                    />
                  );
                },
              )}
            </div>
          );
        })}
      </div>
      {button && (
        <Wrapper className={s.buttonWrapper}>
          <Link withButton href={button.link} className={cn(s.link, 'link')}>
            <Button
              className={s.button}
              analyticsOptions={{
                action: 'click',
                clickZone: 'body',
                clickElement: 'buttonclick',
                clickContent: button.title,
                uniqueId: `autoscrolled-carousel-${button.title}`,
                transitionType: 'inside-link',
                clickZoneCategory: 'site-body',
              }}
            >
              {button.title}
            </Button>
          </Link>
        </Wrapper>
      )}
    </section>
  );
};

export { AutoScrolled };
